module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3724952c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/root/EdNotify.vue
// module id = 1474
// module chunks = 45